<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="showClose"
    :custom-class="dialogClass"
    :top="options.top"
    :width="options.width"
    align-center
    :before-close="handleClose"
    destroy-on-close
  >
    <!-- <p class="dialogTitle">{{ options.dialogTitle }}</p> -->
    <template slot="title">
      <slot name="dialog-header">{{ options.title }}</slot>
    </template>
    <div
      class="dialog__body"
      :style="{ height: options.height, 'overflow-y': 'auto' }"
    >
      <slot name="dialog-body">
        <span>This is a content</span>
      </slot>
    </div>
    <template slot="footer">
      <span class="dialog-footer">
        <el-button
          v-if="options.showCancelButton"
          :class="[options.cancelButtonClass]"
          @click="handleCancel"
        >{{ options.cancelButtonText }}</el-button>
        <el-button
          v-if="options.showConfirmButton"
          :class="[options.confirmButtonClass]"
          type="primary"
          @click="handleConfirm"
        >
          {{ options.confirmButtonText }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
const optionInit = {
  title: 'Tips',
  top: '15vh',
  width: '50%', // dialog body 寬度
  height: 'auto', // dialog body 高度
  showClose: true,
  showCancelButton: true,
  cancelButtonText: '取消',
  cancelButtonClass: 'btn btn-bordered--default',
  showConfirmButton: true,
  confirmButtonText: '確定',
  confirmButtonClass: 'btn btn--primary'
}

export default {
  name: 'HPDialog',
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    option: {
      type: Object,
      default: () => {
        return optionInit
      }
    }
  },
  data() {
    return {
      dialogVisible: true,
      options: optionInit
    }
  },
  computed: {
    showClose() {
      const vm = this
      const state = vm.type === 'normal'
      return !vm.options.showClose ? vm.options.showClose : state
    },
    dialogClass() {
      const vm = this
      const typeClass = vm.type === 'messageBox' ? 'message-box' : 'dialog'
      const optionClass = vm.option.dialogClass || ''
      return optionClass ? `${typeClass} ${optionClass}` : typeClass
    }
  },
  created() {
    const vm = this
    vm.options = {
      ...optionInit,
      ...vm.option
    }
  },
  methods: {
    handleConfirm() {
      const vm = this
      vm.$emit('comfirm')
      // vm.handleClose()
    },
    handleCancel() {
      const vm = this
      vm.$emit('cancel')
      vm.handleClose()
    },
    handleClose() {
      this.$emit('cancel')
    }
  }
}
</script>
